<template>
  <v-container class="fill-height" fluid id="recover-password">
    <v-row>
      <v-col sm="8" offset-sm="2" md="6" offset-md="3" lg="4" offset-lg="4">
        <v-card
          class="elevation-12"
          color="primary"
          v-if="recuperado === false"
        >
          <v-form lazy-validation @submit.prevent="onSubmit">
            <v-card-text>
              <span>
                <v-img :src="'/assets/img/' + logo" width="350px"> </v-img>
              </span>
              <v-text-field
                label="Usuário"
                name="login"
                type="text"
                v-model="payload.email"
                background-color="white"
                solo
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-row>
                <v-col>
                  <div class="text-center">
                    <v-btn color="secondary" type="submit">
                      Solicitar Recuperação de Senha
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-form>
        </v-card>
        <v-card class="elevation-12" color="primary" v-if="recuperado === true">
          <v-card-text>
            <span>
              <v-img :src="'/assets/img/' + logo" width="350px"> </v-img>
            </span>
            <br />
            <h3>
              Solicitação recebida. Verifique a caixa de email ou de SPAM para obter o link de
              recuperação de senha.
            </h3>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { userAPI } from "@/modules/user";

export default {
  data() {
    return {
      payload: {},
      recuperado: false,
      logo: this.$store.state.logo
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    onSubmit() {
      this.setLoading(true);
      userAPI
        .recuperarSenha(this.payload)
        .then(resp => {
          this.setLoading(false);
          this.recuperado = true;
        })
        .catch(resp => {
          this.setLoading(false);
          this.$notification.error("Erro ao recuperar senha!", { timer: 10 });
        });
    }
  }
};
</script>
